import React, { useState } from "react";
import { Button, Divider, makeStyles } from "@material-ui/core";
import { GetApp, OpenInNew } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import {
  parseDocumentName,
  getDocumentExtension,
  getDocumentIcon,
  canPreviewDocument,
} from "../../helpers/mediaPlaceholder";

const useStyles = makeStyles(theme => ({
  documentCard: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 12px",
    background: "rgba(0,0,0,0.03)",
    borderRadius: 8,
    marginBottom: 4,
    maxWidth: 350,
  },
  docIcon: {
    fontSize: 32,
    lineHeight: 1,
    flexShrink: 0,
  },
  docInfo: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
  },
  docName: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  docType: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
  },
  docActions: {
    display: "flex",
    gap: 4,
    flexShrink: 0,
  },
  iconBtn: {
    padding: 6,
    minWidth: "auto",
  },
  pdfPreview: {
    width: "100%",
    maxWidth: 350,
    height: 300,
    border: "1px solid rgba(0,0,0,0.1)",
    borderRadius: 8,
    marginBottom: 4,
    background: "#f5f5f5",
  },
}));

const DocumentPreview = ({ message }) => {
  const classes = useStyles();
  const [previewFailed, setPreviewFailed] = useState(false);

  const displayName =
    parseDocumentName(message.body) || i18n.t("mediaPlaceholder.document");
  const ext = getDocumentExtension(message.mediaUrl);
  const icon = getDocumentIcon(ext);
  const showPreview = canPreviewDocument(ext) && !previewFailed;

  return (
    <>
      {showPreview && (
        <iframe
          className={classes.pdfPreview}
          src={message.mediaUrl}
          title={displayName}
          onError={() => setPreviewFailed(true)}
        />
      )}
      <div className={classes.documentCard}>
        <span className={classes.docIcon} role="img" aria-label="document">
          {icon}
        </span>
        <div className={classes.docInfo}>
          <span className={classes.docName} title={displayName}>
            {displayName}
          </span>
          {ext && <span className={classes.docType}>{ext}</span>}
        </div>
        <div className={classes.docActions}>
          <Button
            className={classes.iconBtn}
            color="primary"
            target="_blank"
            href={message.mediaUrl}
            title={i18n.t("documentPreview.openInNew")}
          >
            <OpenInNew fontSize="small" />
          </Button>
          <Button
            className={classes.iconBtn}
            color="primary"
            variant="contained"
            target="_blank"
            href={message.mediaUrl}
            download
            title={i18n.t("documentPreview.download")}
          >
            <GetApp fontSize="small" />
          </Button>
        </div>
      </div>
      <Divider />
    </>
  );
};

export default DocumentPreview;
